__webpack_require__.p = "https://wastehero-frontend-f60ykx0ix-wastehero.vercel.app/";